// http-context.tokens.ts
import { HttpContextToken } from '@angular/common/http';

export const SKIP_CORS_FIX = new HttpContextToken<boolean>(() => false);
